import PlaceDetail from "../../components/PlaceDetail/PlaceDetail";
import { MainLayout } from "../../Layout";

export const PlaceDetails = () => {
  return (
    <MainLayout>
      <PlaceDetail />
    </MainLayout>
  );
};
